import React, { memo, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChatListDataContext, GroupDataContext, SignalRContext, UsersDataContext } from "../../layout/Baselayout";
import defaultUserPic from "../../assets/img/user-profile.svg";
import groupPic from "../../assets/img/multi-user-icon.svg";
import { getExtensionType, getFormattedDateTime, truncateWords, audioformatTime, recordingformatTime } from "../../utils";
import Picker from "emoji-picker-react";
import { IMAGE_URL } from "../../configs/api";
import * as chatService from "../../services/chatService";
import Modal from "../../utils/Modal";
import NewGroup from "../newGroup/NewGroup";
import Message from "../message/Message";
import UserProfileModal from "../../utils/UserProfileModal";
import Preview from "../preview/preview";
import pdf_icon from "../../assets/img/pdf-icon.png";
import word_icon from "../../assets/img/word-icon.png";
import excl_icon from "../../assets/img/excl-icon.png";
import csv_icon from "../../assets/img/csv-icon.png";
import ppt_icon from "../../assets/img/ppt-icon.png"
import other_file_icon from "../../assets/img/other-file-icon.png";
import audio_file_icon from "../../assets/img/audioF.png"
import { useCall } from "../../services/callProviderContext";

const Chat = () => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const users = JSON.parse(localStorage.getItem("users"));
  const extensionIcons = { pdf: pdf_icon, doc: word_icon, docx: word_icon, txt: word_icon, ppt: ppt_icon, pptx: ppt_icon, csv: csv_icon, xls: excl_icon, xlsx: excl_icon, audio: audio_file_icon };

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif", "heic"];

  const documentExtensions = ["pdf", "doc", "docx", "txt", "ppt", "pptx", "csv", "xls", "xlsx"]

  const audioExtensions = [
    "3gp", "aa", "aac", "aax", "ac3", "aiff", "alac", "amr", "ape", "au",
    "dts", "flac", "gsm", "m4a", "m4b", "m4p", "mka", "mlp", "mod", "mp3",
    "mpa", "mpc", "msv", "oga", "ogg", "opus", "ra", "ram", "raw", "snd",
    "spx", "tta", "voc", "vqf", "wav", "wma", "wv"
  ];

  const { incomingCall, setIncomingCall, startCall } = useCall();
  const [connection, onlineUsers] = useContext(SignalRContext);
  const usersData = useContext(UsersDataContext);
  const { setChatListItem, activeChats, callingFlag, setCallingFlag, setCurrCallUser } = useContext(ChatListDataContext);
  const [activeGroups, setActiveGroups] = useContext(GroupDataContext);

  const messagesEndRef = useRef(null);
  const messageDataRef = useRef({});
  const generatedFilenameRef = useRef("");
  const roomIdRef = useRef(null);
  const fileInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const intervalRef = useRef(null);
  const textareaRef = useRef(null);
  const onlineUsersRef = useRef(onlineUsers);
  const containerRef = useRef(null);


  const currentUserId = loginData?.id?.toString();
  const { id } = useParams();
  const roomId = id?.split("_")[0];
  const navigate = useNavigate();
  // const navigate = useNavigate();
  const [messageData, setMessageData] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const [currChatUser, setCurrChatUser] = useState({});
  const [currGroup, setCurrGroup] = useState({});
  const [attachMultiFile, setAttachMultiFile] = useState([]);
  const [emojiPicker, setEmojiPicker] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [deleteChatFlag, setDeleteChatFlag] = useState(false);
  const [forwardChatFlag, setForwardChatFlag] = useState(false);
  const [replyChatFlag, setReplyChatFlag] = useState(false);
  const [selectedForwardMessages, setSelectedForwardMessages] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [showPrevMsg, setShowPrevMsg] = useState(true);
  const [IsLoading, setloading] = useState(false);
  const [isScroll, setIsScroll] = useState(null);
  const [currMsg, setCurrMsg] = useState({});
  const [replyMsg, setReplyMsg] = useState({});
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [timer, setTimer] = useState(0);
  const [stopTimeoutId, setStopTimeoutId] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(null);
  const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 786);
  const [modalAction, setModalAction] = useState({
    deleteMessage: false,
    updateGroup: false,
    leaveGroup: false,
    membersList: false,
    forwardMsg: false,
    calling: false,
    userProfile: false,
  });

  //checking screen size
  useEffect(() => {
    const handleResize = () => setIsWideScreen(window.innerWidth > 786);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //mouse scroll on multiple file attachment
  useEffect(() => {
    const container = containerRef.current;

    const handleWheel = (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    };

    if (container) {
      container.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  // textareaRef.current
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [attachMultiFile, replyChatFlag, audioURL, emojiPicker]);

  // Update the ref whenever onlineUsers changes
  useEffect(() => {
    onlineUsersRef.current = onlineUsers;
  }, [onlineUsers]);

  // Handle click outside to close the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          buttonRef.current &&
          !buttonRef.current.contains(event.target)) ||
        (emojiPickerRef.current &&
          !emojiPickerRef.current.contains(event.target))
      ) {
        setIsOpen(false);
        setEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scrollend", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleScroll = (e) => {
    console.log("e: ", e);
  };

  const onClickToggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleInputChange = (value) => {
    setNewMessage(value);
    setIsTyping(value.length > 0);
  };

  useEffect(() => {
    if (id) {
      const userId = id.split("_")[1];
      let user = activeChats.find((u) => u.id == userId);
      if (!user) {
        user = usersData.find((u) => u.id == userId);
      }

      // Set the current chat user if found
      if (user) {
        setCurrChatUser(user);
      } else {
        setCurrChatUser(null)
      }
    }
  }, [id, usersData, activeChats]);

  useEffect(() => {
    if (id) {
      const userId = id.split("_")[1];
      const currGroup = activeGroups?.find(
        (user) => user.id.toString() === userId
      );
      setCurrGroup(currGroup);
    }
  }, [id, activeGroups]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "auto" });
    }
  };

  useEffect(() => {
    messageDataRef.current = messageData; // Keep the ref updated with the latest state
    if (isScroll === null) {
      scrollToBottom();
    }
  }, [messageData.messages]);

  useEffect(() => {
    roomIdRef.current = currGroup?.roomId; // Keep the ref updated with the latest state
  }, [currGroup]);

  //handle delete messages
  useEffect(() => {
    if (!connection) return;

    connection.on("DeleteMessage", (data) => {
      const url =
        messageDataRef.current.type === "Group Chat"
          ? `/chat/${data.roomId}_${messageDataRef?.current.groupId}`
          : `/chat/${data.roomId}_${data.loginId}`;

      if (url === window.location.pathname) {
        setMessageData((prevMessageData) => ({
          ...prevMessageData,
          messages: prevMessageData.messages.filter(
            (message) => !data.messageIds.includes(message.id)
          ),
        }));
      }
    });

    return () => {
      connection.off("DeleteMessage");
    };
  }, [connection]);

  // Handle private messages
  useEffect(() => {
    if (!connection) return;
    const handleReceiveMessage = async (chat) => {
      if (chat.roomId) {
        roomIdRef.current = chat.roomId;
      }

      if (chat?.roomId === messageDataRef.current?.roomId || chat?.roomId === roomId) {

        if (chat.receiverId.toString() === loginData.id.toString()) {
          const lastMessageId = messageDataRef.current?.messages?.length ? messageDataRef.current.messages[messageDataRef.current.messages.length - 1].id : 0;

          const updateReadStatus = {
            userid: loginData.id,
            messageId: [lastMessageId + 1],
            roomId: chat?.roomId,
            readStatus: chat.senderId != loginData.id ? 2 : onlineUsersRef?.current.includes(chat?.receiverId?.toString()) ? 1 : 0,
            // readStatus: 2,
          }

          if (connection.state === 'Connected') {
            await connection.invoke("MessageDelivered", updateReadStatus);
          }

        }


        setMessageData((prevData) => {
          const lastMessageId = prevData?.messages?.length ? prevData.messages[prevData.messages.length - 1].id : 0;
          const isReceiver = chat.receiverId.toString() === loginData.id.toString();

          return {
            ...prevData,
            messages: [
              ...(prevData?.messages || []),
              {
                id: lastMessageId + 1,
                message: chat.message,
                mediaUrl: chat.mediaUrl,
                userid: chat.senderId.toString(),
                date: getFormattedDateTime(),
                userName: chat.senderName,
                readstatus: isReceiver ? 0 : onlineUsersRef?.current?.includes(chat.receiverId?.toString()) ? 1 : 0,
                parentMessageId: chat.parentMessageId,
                parentMessage: chat.parentMessage,
                parentMediaUrl: chat.parentMediaUrl,
                parentUserName: chat.parentUserName
              },
            ],
          };
        });
      }
    };
    connection?.on("ReceiveMessage", handleReceiveMessage);
  }, [connection]);

  // Handle group messages
  useEffect(() => {
    if (!connection) return;
    const handleReceiveRoomMessage = (chat) => {
      if (
        chat?.roomId === messageDataRef.current?.roomId ||
        chat?.roomId === roomIdRef.current
      ) {
        setMessageData((prevData) => {
          const lastMessageId = prevData?.messages?.length ? prevData.messages[prevData.messages.length - 1].id : 0;

          return {
            ...prevData,
            roomId: chat?.roomId,
            messages: [
              ...(prevData?.messages || []),
              {
                id: lastMessageId + 1,
                message: chat.message,
                mediaUrl: chat.mediaUrl,
                userid: chat.senderId,
                userName: chat.senderName,
                date: getFormattedDateTime(),
                parentMessageId: chat.parentMessageId,
                parentMessage: chat.parentMessage,
                parentMediaUrl: chat.parentMediaUrl,
                parentUserName: chat.parentUserName
              },
            ],
          };
        });
      }
    };
    connection?.on("ReceiveRoomMessage", handleReceiveRoomMessage);
  }, [connection]);

  const openPreview = (msg) => {
    setCurrMsg(msg);
  };

  const closePreview = () => {
    setCurrMsg(null)
  };

  const getMessages = async () => {
    if (!connection) return;

    const data = {
      roomid: roomId,
      userid: loginData?.id,
    };

    try {
      let response = await chatService.getMessageList(data);

      if (response.status === 200) {
        let result = await response.json();

        if (result && result.messages) {
          setMessageData(result);
        }

        // Get unread messages from other users
        const messageIds = result.messages
          ?.filter(
            (msg) =>
              (msg?.userid !== loginData?.id.toString() || msg?.id === 1) && (msg?.readstatus < 2)
          )
          ?.map((msg) => msg.id);

        if (!messageIds || messageIds?.length === 0) return;

        // Update status to "seen" (2) since user is viewing the chat
        const updateReadStatus = {
          userid: loginData.id,
          messageId: messageIds,
          roomId: result.roomId,
          readstatus: result.messages.length === 1 && messageIds[0] === 1 ? onlineUsersRef?.current.includes(result?.receiverId?.toString()) ? 1 : 0 : 2,
        };

        if (connection.state === 'Connected') {
          await connection.invoke("MessageDelivered", updateReadStatus);
        }
      } else {
        setMessageData({});
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getMessages();
    }
    setIsScroll(null);
  }, [id, connection]);

  useEffect(() => {
    setNewMessage("");
    setEmojiPicker(false);
    setMessageData({});
    setDeleteChatFlag(false);
    setSelectedMessages([]);
    setForwardChatFlag(false);
    setSelectedForwardMessages([]);
    setShowPrevMsg(true);
    setReplyChatFlag(false);
    setAudioURL(null);
    setReplyMsg({});
    setAttachMultiFile([]);
  }, [id]);

  // Read status handler
  useEffect(() => {
    if (!connection) return;

    const handleReadStatus = (chat) => {
      const isCurrentChat = window.location.pathname === `/chat/${chat.roomId}_${chat.userid}`;

      // No delay needed if we're using refs
      setMessageData(prev => {
        if (prev.roomId !== chat.roomId) return prev;

        return {
          ...prev,
          messages: prev.messages?.map(message => ({
            ...message,
            readstatus: chat.messageId.includes(message.id)
              ? chat.readStatus
              : message.readstatus
          }))
        };
      });
    };

    connection.on("MessageDeliveredToSender", handleReadStatus);

    return () => {
      connection.off("MessageDeliveredToSender", handleReadStatus);
    };
  }, [connection]);

  useEffect(() => {
    const receiverId = currChatUser?.id?.toString(); // Ensure string comparison
    if (!receiverId || !connection) return;
    const isReceiverOnline = onlineUsers.includes(receiverId);

    const sendDeliveredStatus = async () => {
      const messageIds = messageDataRef?.current?.messages
        ?.filter(
          (msg) =>
            msg?.userid === loginData?.id.toString() && (msg?.readstatus < 1)
        )
        ?.map((msg) => msg.id);

      if (!messageIds || messageIds?.length === 0) return;

      const updateReadStatus = {
        userid: loginData.id,
        messageId: messageIds,
        roomId: roomId,
        readStatus: 1,
      };

      try {
        await connection.invoke("MessageDelivered", updateReadStatus);
      } catch (error) {
        console.error("Failed to invoke MessageDelivered", error);
      }
    };

    if (isReceiverOnline) {
      sendDeliveredStatus();
    }
  }, [connection, onlineUsers]); // Only depend on connection and onlineUsers

  const messageIdGenerator = (fileName = "") => {
    // Extract the filename without extension
    const originalName = fileName.split(".").slice(0, -1).join(".");
    const extension = fileName.split(".").pop();

    // Generate a timestamp-based unique identifier
    const timestamp = new Date().getTime().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 6);

    // Combine them to create a unique filename
    return `${originalName}_${timestamp}${randomPart}`;
  };

  {/*----------file on change operation ---------------- */ }

  const handleFileOnChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const fileReadPromises = Array.from(files).map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (loadEvent) => {
          resolve({
            filename: file.name,
            type: file.type,
            data: loadEvent.target.result,
          });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileReadPromises).then((newFiles) => {
      // Append new files to existing state (instead of overriding)
      setAttachMultiFile((prevFiles) => [...prevFiles, ...newFiles]);

      // Preview the first file of the new selection (optional)
      if (newFiles.length > 0) {
        setImagePreview(newFiles[0].data);
        generatedFilenameRef.current = messageIdGenerator(newFiles[0].filename);
      }

      // Append generated filenames to ref
      const newGeneratedNames = newFiles.map((file) =>
        messageIdGenerator(file.filename)
      );

      generatedFilenameRef.current = [

        ...newGeneratedNames,
      ];
    });
  };

  {/*----------paste file operation ---------------- */ }
  const handlePasteImage = async (e) => {
    const items = e.clipboardData.items;
    let hasFile = false;

    // Check all items in clipboard
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.kind === 'file') {
        e.preventDefault();
        hasFile = true;
        const blob = item.getAsFile();
        let filename = blob.name;
        const isScreenshot = filename === 'image.png';

        // Handle different file types
        if (item.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.readAsDataURL(blob);

          if (isScreenshot) {
            filename = `screenshot-${Date.now()}.png`;
          }

          reader.onload = async (event) => {
            const base64String = event.target.result;
            const ext = item.type.split('/')[1] || 'png';
            const newFile = {
              filename,
              type: item.type,
              data: base64String
            };
            // Add to existing files instead of replacing
            setAttachMultiFile(prevFiles => [...prevFiles, newFile]);

            // Set preview for the last pasted image
            setImagePreview(base64String);
            setNewMessage("");

            // Add generated filename to the ref array
            generatedFilenameRef.current = [...generatedFilenameRef.current, messageIdGenerator(filename)];
          };
        } else {
          // Handle non-image files
          const reader = new FileReader();
          reader.readAsDataURL(blob);

          reader.onload = async (event) => {
            const base64String = event.target.result;
            const ext = blob.name.split('.').pop() || 'file';
            const newFile = {
              filename,
              type: item.type,
              data: base64String
            };
            setAttachMultiFile(prevFiles => [...prevFiles, newFile]);
            setNewMessage("");

            // Add generated filename to the ref array
            generatedFilenameRef.current = [...generatedFilenameRef.current, messageIdGenerator(filename)];
          };
        }
        return;
      }
    }

    // If no files, handle text
    const pastedText = e.clipboardData.getData('text/plain');
    if (pastedText) {
      return;
    }
  };

  {/*----------send message ---------------- */ }

  const handleSendMessage = async (e) => {
    if (isSending) return;
    setIsSending(true);

    try {
      const filePaths = [];
      let lastFileUrl = "";

      // Upload all files first
      if (attachMultiFile.length > 0) {
        for (const [index, file] of attachMultiFile.entries()) {
          const fileExtension = getExtensionType(file?.filename);
          const generatedFilename = generatedFilenameRef.current[index];

          const uploadData = {
            filename: `${generatedFilename}.${fileExtension}`,
            message: "Default",
            requestParam: {
              fileAsBase64: file.data,
            },
          };

          const uploadFileRes = await chatService.uploadFile(uploadData);
          if (uploadFileRes.status === 200) {
            const fileUrl = `${IMAGE_URL}/${generatedFilename}.${fileExtension}`;
            filePaths.push(fileUrl);
            lastFileUrl = fileUrl; // Keep updating to get the last file

            // Send message for all files except the last one
            if (index < attachMultiFile.length - 1) {
              const fileMessageData = {
                senderId: loginData?.id,
                receiverId: currChatUser?.id ? currChatUser.id : 0,
                roomId: roomId === "new" ? "" : roomId,
                mediaUrl: fileUrl,
                message: "", // Empty message for intermediate files
                senderName: loginData?.userName,
                parentMessageId: replyMsg ? replyMsg?.id : null,
                parentMessage: replyMsg ? replyMsg?.message : null,
                parentUserName: replyMsg ? replyMsg?.userName : null,
                parentMediaUrl: replyMsg ? replyMsg?.mediaUrl : null,
              };

              if (currGroup?.id) {
                await connection.invoke("SendRoomMessage", fileMessageData);
              } else {
                await connection.invoke("SendMessage", fileMessageData);
              }
            }
          }
        }
      }

      // Prepare the final message data (combines text with last file if exists)
      const finalMessageData = {
        senderId: loginData?.id,
        receiverId: currChatUser?.id ? currChatUser.id : 0,
        roomId: roomId === "new" ? "" : roomId,
        mediaUrl: attachMultiFile.length > 0 ? lastFileUrl : "", // Only include last file
        message: newMessage,
        senderName: loginData?.userName,
        parentMessageId: replyMsg ? replyMsg?.id : null,
        parentMessage: replyMsg ? replyMsg?.message : null,
        parentUserName: replyMsg ? replyMsg?.userName : null,
        parentMediaUrl: replyMsg ? replyMsg?.mediaUrl : null,
      };

      // Send the final combined message
      if (currGroup?.id) {
        await connection.invoke("SendRoomMessage", finalMessageData);
      } else {
        await connection.invoke("SendMessage", finalMessageData);
      }

      // Reset all states
      setNewMessage("");
      setAttachMultiFile([]);
      setImagePreview(null);
      setReplyMsg(null);
      setReplyChatFlag(false);
      setAudioURL(null);
      setIsTyping(false);
      generatedFilenameRef.current = [];
      scrollToBottom();
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    const allowed = sessionStorage.getItem("token");
    if (!allowed) {
      navigate("/");
    }
  }, [navigate]);

  const onEmojiClick = (event) => {
    setNewMessage((prev) => prev + event?.emoji);
  };

  const getFormattedDate = (msgDate) => {
    const messageDateStr = msgDate.replace(" at", "");

    const messageDate = new Date(messageDateStr);

    if (isNaN(messageDate)) {
      return "Invalid Date";
    }

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = messageDate.toLocaleDateString("en-GB", options);

    if (isSameDay(messageDate, today)) {
      return "Today";
    } else if (isSameDay(messageDate, yesterday)) {
      return "Yesterday";
    } else {
      return formattedDate;
    }
  };

  const isSameDay = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const handleOnKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (newMessage.trim() || attachMultiFile.length > 0) {
        handleSendMessage();
      }
    } else if (event.key === "Enter" && event.shiftKey) {
      const cursorPosition = event.target.selectionStart;
      const textBefore = newMessage.substring(0, cursorPosition);
      const textAfter = newMessage.substring(cursorPosition);

      handleInputChange(textBefore + "\n" + textAfter);
      event.preventDefault();
    }
  };

  {/*--------------- Function to handle checkbox selection / delete message --------------- */ }
  const handleCheckDelMsgChange = (messageId) => {
    setSelectedMessages((prevSelected) =>
      prevSelected.includes(messageId)
        ? prevSelected.filter((id) => id !== messageId)
        : [...prevSelected, messageId]
    );
  };
  const handleSelectAllToggle = () => {
    if (isAllSelected) {
      // Unselect all messages
      setSelectedMessages([]);
      setIsAllSelected(false);
    } else {
      const filteredMessageIds = messageData.messages
        .filter((msg) => msg.userid.toString() === loginData?.id.toString())
        .map((msg) => msg.id);
      setSelectedMessages(filteredMessageIds);
      setIsAllSelected(true);
    }
  };

  const handleCancelSelection = () => {
    setSelectedMessages([]);
    setDeleteChatFlag(false);
  };

  // Function to open the "Delete Message" modal
  const onDeleteMessage = () => {
    setDeleteChatFlag(true);
    setIsOpen(false);
  };

  const handleDeleteSelected = async () => {
    try {
      if (selectedMessages?.length > 0) {
        const data = {
          roomId: roomId,
          messageIds: selectedMessages,
        };
        const response = await chatService.deleteMessage(data);
        if (response.status === 200) {
          const updatedMessages = messageData.messages.filter(
            (msg) => !selectedMessages.includes(msg.id)
          );
          setMessageData((prevData) => ({
            ...prevData,
            messages: updatedMessages,
          }));
          handleCancelSelection();
          closeModal();
          setSelectedMessages([]);
          setIsAllSelected(false);
        }
      }
    } catch (error) {
      console.error("Error deleting selected messages:", error);
    }
  };

  {/* ------------------ Clear chat history -------------------- */ }
  // Function to open the "Clear Chat" modal
  const openClearChatModal = () => {
    setModalType("chat");
    setIsOpen(false);
  };

  const handleClearChatClick = useCallback(async () => {
    const data = {
      userid: loginData?.id,
      clearuserid: currChatUser?.id,
    };
    if (currChatUser?.id) {
      await chatService
        .clearHistoryChat(data)
        .then(async (response) => {
          if (response.status === 200) {
            setChatListItem({
              id: currChatUser.id,
              type: "delete-chat-item",
            });
            navigate("/chat");
            setIsOpen(false);
            setModalType(null);
          } else {
            console.log("clear chat");
          }
        })
        .catch((error) => {
          console.log("clearchat history api error", error);
        });
    }
  }, [currChatUser]);

  {/* ------------------ reply set scroll when click on reply msg ------------------ */ }
  useEffect(() => {
    if (replyChatFlag || attachMultiFile.length > 0) {
      setIsScroll(scrollToBottom);
    }
  }, [replyChatFlag, attachMultiFile]);

  {/* ------------------ Delete group ------------------ */ }

  // Function to open the "Delete Group" modal
  const openDeleteGroupModal = () => {
    setModalType("group");
    setIsOpen(false);
  };
  const openUpdateGroupModal = () => {
    setModalAction({ ...modalAction, updateGroup: true });
  };

  const handleDeleteGroup = useCallback(async () => {
    const groupId = id?.split("_")[1];
    await chatService
      .deleteGroup(groupId)
      .then(async (response) => {
        if (response.status === 200) {
          let result = await response.json();
          setChatListItem({
            id: result.id,
            type: "delete-group-item",
          });
          setActiveGroups((prevState) =>
            prevState.filter((group) => group.id.toString() !== groupId)
          );
          navigate("/chat");
          setModalType(null);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, [id]);

  {/* ------------------ Leave Group ------------------ */ }

  // Function to open the "Leave Group" modal
  const openLeaveGroupModal = () => {
    setModalAction({ ...modalAction, leaveGroup: true });
    setIsOpen(false);
  };

  const handleLeaveGroup = useCallback(async () => {
    const data = {
      userId: loginData?.id,
      groupId: currGroup?.id,
    };
    if (currGroup?.id) {
      await chatService
        .leaveGroup(data)
        .then(async (response) => {
          if (response.status === 200) {
            let result = await response.json();
            setChatListItem({
              id: result.id,
              type: "leave-group-item",
            });
            setActiveGroups((prevState) =>
              prevState.filter((group) => group.id !== data.groupId)
            );
            navigate("/chat");
            setModalType(null);
            closeModal();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [currGroup]);

  const closeModal = () => {
    setModalType(null);
    setModalAction({});
    setForwardChatFlag(false);
    setIncomingCall(null);
    setSelectedForwardMessages([]);
  };

  {/* ------------------ forward message ------------------ */ }
  // forward message
  const onForwardMessage = () => {
    setForwardChatFlag(true);
    // setIsOpen(false);
  };

  const handleCancelForwardMessage = () => {
    setForwardChatFlag(false);
    setSelectedForwardMessages([]);
  };

  const handleCheckForwardNessage = (msg) => {
    setSelectedForwardMessages(
      (prev) =>
        prev.some((m) => m.id === msg.id)
          ? prev.filter((m) => m.id !== msg.id) // Remove if already selected
          : [...prev, msg] // Add if not selected
    );
  };

  const groupMessagesByDate = (messages) => {
    const groupedMessages = {};

    messages?.forEach((msg) => {
      const formattedDate = getFormattedDate(msg.date);

      if (!groupedMessages[formattedDate]) {
        groupedMessages[formattedDate] = [];
      }

      groupedMessages[formattedDate].push(msg);
    });

    return groupedMessages;
  };

  {/* ------------------ handle back ------------------ */ }

  useEffect(() => {
    const handlePopState = () => {
      navigate("/chat");
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const handleBack = () => {
    navigate("/chat");
    // window.location.href = "/chat";
  };

  const handleOnCall = () => {
    setModalAction({ ...modalAction, calling: true });
    setCallingFlag(true);
    const data = users.find(
      (user) => user?.username === currChatUser?.userName
    );

    const socketIds = users
      .filter(user =>
        currGroup?.users.split(',').includes(user?.userId.toString()) &&
        user.userId !== loginData.id
      )
      .map(user => user.socketId)
      .filter(socketId => socketId !== null);

    setCurrCallUser(currChatUser ? currChatUser : currGroup);
    if (currChatUser) {
      startCall(data, currChatUser);
    } else {
      // startGroupCall(socketIds, currGroup);
    }
  };
  // -----------------------load previews massage-------------------//
  const LoadPreviewsmassage = async () => {
    setloading(true);
    const container = document.getElementById("conversation");
    const previousScrollHeight = container.scrollHeight;
    const previousScrollTop = container.scrollTop;

    await chatService
      .PreviousMessages(roomId, messageDataRef.current.messages[0].id)
      .then((response) => {
        if (response.length === 0) {
          setShowPrevMsg(false);
        }
        setMessageData((prevMessageData) => ({
          ...prevMessageData,
          messages: [...response, ...prevMessageData.messages],
        }));
        setloading(false);

        requestAnimationFrame(() => {
          const newScrollHeight = container.scrollHeight;
          const heightDiff = newScrollHeight - previousScrollHeight;
          const newScrollTop = previousScrollTop + heightDiff;
          container.scrollTo(0, newScrollTop);
        });

      });
  };

  {/*------------------ recording functionality ------------------ */ }
  // Audio control functions
  const handleAudioPlay = (audioId, audioElement) => {
    if (currentlyPlayingAudio && currentlyPlayingAudio !== audioElement) {
      currentlyPlayingAudio.pause();
      currentlyPlayingAudio.currentTime = 0;
    }

    // Toggle play/pause
    if (audioElement.paused) {
      audioElement.play();
      setCurrentlyPlayingAudio(audioElement);
      setCurrentlyPlayingId(audioId);
    } else {
      audioElement.pause();
      setCurrentlyPlayingId(null);
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStreamRef.current = stream;

      // Clear previous interval/timeout
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (stopTimeoutId) clearTimeout(stopTimeoutId);

      setTimer(0);

      // Use AAC in MP4 container (best for iOS)
      const options = { mimeType: 'audio/mp4; codecs=mp4a.40.2' };
      const mediaRecorder = new MediaRecorder(stream, options);
      const audioChunks = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) audioChunks.push(event.data);
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/mp4' });

        const reader = new FileReader();
        reader.onloadend = () => {
          setAttachMultiFile([{
            filename: `audio-${Date.now()}.m4a`, // iOS prefers .m4a for AAC
            type: "audio",
            data: reader.result,
          }]);
          setAudioURL(URL.createObjectURL(audioBlob));
        };
        reader.readAsDataURL(audioBlob);
      };

      // generatedFilenameRef.current = `audio_${Date.now()}`;
      generatedFilenameRef.current = [...generatedFilenameRef.current, `audio_${Date.now()}`];

      mediaRecorder.start();
      mediaRecorderRef.current = mediaRecorder;
      setRecording(true);

      // Update timer
      intervalRef.current = setInterval(() => setTimer(prev => prev + 1), 1000);
      setStopTimeoutId(setTimeout(stopRecording, 15 * 60 * 1000));
    } catch (err) {
      alert("Microphone access denied");
      console.error(err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();

      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach(track => track.stop());
        mediaStreamRef.current = null;
      }

      setRecording(false);

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }


      if (stopTimeoutId) {
        clearTimeout(stopTimeoutId);
        setStopTimeoutId(null);
      }

      setTimer(0);
    }
  };

  const handleCancelRecording = () => {
    setRecording(false);
    setAudioURL(null);
    setAttachMultiFile([]);
    // if (mediaRecorderRef.current) {
    //   mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
    //   mediaRecorderRef.current = null;
    // }
  };
  const handleDeleterecording = () => {
    if (mediaRecorderRef.current?.state === 'recording') {
      mediaRecorderRef.current.ondataavailable = null;
      mediaRecorderRef.current.onstop = null;
      mediaRecorderRef.current.stop();
    }

    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach(track => track.stop());
      mediaStreamRef.current = null;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (stopTimeoutId) {
      clearTimeout(stopTimeoutId);
      setStopTimeoutId(null);
    }

    setRecording(false);
    setAudioURL(null);
    setAttachMultiFile([]);
    setTimer(0);
    setReplyChatFlag(false);
  };

  const groupedMessages = groupMessagesByDate(messageData?.messages);

  const isUserOnline = currChatUser && onlineUsers.includes(currChatUser?.id?.toString());

  return (
    <>
      {!id ? (
        <div className="chat-container">
          <div className="welcome-message">
            <h2>Welcome to Loopapot Messenger!</h2>
            <p>Select a user to start chatting or wait for new messages.</p>
          </div>
        </div>
      ) : (
        <>
          <div
            className="row heading pl-2"
            onScrollEnd={(e) => console.log("scrollend  e: ", e)}
          >
            <div className="col-sm-8 col-xs-7 heading-name">
              <div className="d-flex a-itemend">
                <i
                  className="fa fa-2x fa-arrow-left mr-2 pull-right backarrow-mobile"
                  aria-hidden="true"
                  onClick={handleBack}
                ></i>
                <span
                  className="tophwidth"
                  onClick={() => {
                    if (currGroup?.id) {
                      setModalAction({ ...modalAction, membersList: true });
                    } else {
                      setModalAction({ ...modalAction, userProfile: true });
                    }
                  }}
                >
                  <img
                    src={!currChatUser ? groupPic : defaultUserPic}
                    alt={currChatUser?.userName}
                    className="w-100"
                  />
                </span>
                <div className="topiconprofile">
                  <span
                    className="sta-name"
                    onClick={() => {
                      if (currGroup?.id) {
                        setModalAction({ ...modalAction, membersList: true });
                      } else {
                        setModalAction({ ...modalAction, userProfile: true });
                      }
                    }}
                  >
                    <a className="heading-name-meta">
                      {!currChatUser
                        ? currGroup?.groupName ||
                        messageDataRef?.current?.groupName
                        : currChatUser?.userName}
                    </a>
                    {currChatUser ? (
                      <span className="heading-online">
                        {isUserOnline ? "Online" : "Offline"}
                      </span>
                    ) : (
                      <span className="heading-online">Group</span>
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-3 col-xs-4 heading-dot pull-right dropdown">
              <i
                ref={buttonRef}
                className="fa fa-ellipsis-v fa-2x  pull-right"
                aria-hidden="true"
                onClick={onClickToggleDropdown}
              ></i>
              {currChatUser?.id && <i
                className="fa fa-2x fa-phone mr-2 pull-right"
                aria-hidden="true"
                style={incomingCall || callingFlag ? { opacity: 0.5, pointerEvents: 'none', cursor: 'not-allowed' } : {}}
                onClick={() => incomingCall || callingFlag ? null : handleOnCall()}
              // onClick={()=> handleOnCall()}
              />}
            </div>
            {isOpen && (
              <div className="dropdown-new" ref={dropdownRef}>
                <ul>
                  {Object.keys(messageDataRef.current).length > 0 && (
                    <li onClick={onDeleteMessage}>Delete Message</li>
                  )}
                  {currChatUser?.id && (
                    <li onClick={openClearChatModal}>Clear Chat</li>
                  )}
                  {currGroup?.id && (
                    <li onClick={openLeaveGroupModal}>Leave Group</li>
                  )}
                  {currGroup?.id && loginData.id === currGroup?.createdBy && (
                    <li onClick={openUpdateGroupModal}>Update Group</li>
                  )}
                  {currGroup?.id && loginData.id === currGroup?.createdBy && (
                    <li onClick={openDeleteGroupModal}>Delete Group</li>
                  )}
                </ul>
              </div>
            )}
            {/* <div className="col-sm-1 col-xs-2 heading-compose  pull-right">
              <i
                className="fa fa-phone fa-2x  pull-right"
                aria-hidden="true"
                onClick={() => setModalAction({ ...modalAction, calling: true })}
              />
            </div> */}
          </div>

          {/* Chat Messages */}
          {isSending && attachMultiFile.length > 0 && (
            <div className="loader-overlay">
              <span className="loader"></span>
            </div>
          )}
          <div
            className="row message"
            id="conversation"
            onScrollEnd={(e) => setIsScroll(e.target.scrollTop)}
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (Array.from(e.dataTransfer.items).some(item => item.kind === 'file')) {
                e.currentTarget.classList.add('drag-active');
              }
            }}
            onDragLeave={(e) => {
              e.preventDefault();
              e.stopPropagation();
              e.currentTarget.classList.remove('drag-active');
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              e.currentTarget.classList.remove('drag-active');

              const files = e.dataTransfer.files;
              if (files && files.length > 0) {
                const event = {
                  target: {
                    files: files
                  }
                };
                handleFileOnChange(event);
              }
            }}
          >
            {messageData?.messages?.length >= 100 && showPrevMsg && (
              <div className="col-sm-12 previous">
                <button
                  className="btn btn-link load-more-btn"
                  onClick={LoadPreviewsmassage}
                >
                  {IsLoading ? (
                    <div className="spinner-container">
                      <div className="spinner"></div>
                      {/* <span className="loading-text">Loading...</span> */}
                    </div>
                  ) : (
                    "Show Previous Messages"
                  )}
                </button>
              </div>
            )}

            {Object.keys(groupedMessages).map((date, index) => {

              return (
                <React.Fragment key={`${date}_${index}`}>
                  {/* Show "Load More" button before the first date group if we're not showing all */}
                  <h5 style={{ color: "black", textAlign: "center" }}>
                    {date}
                  </h5>

                  {groupedMessages[date].map((msg, msgIndex) => {
                    const senderName =
                      msg.userid.toString() === loginData?.id?.toString()
                        ? "You"
                        : messageData?.participants?.find(
                          (participant) =>
                            participant?.userId?.toString() ===
                            msg?.userid?.toString()
                        )?.userName;
                    return (
                      <React.Fragment key={msgIndex}>
                        <Message
                          msg={msg}
                          currGroup={currGroup}
                          senderName={senderName}
                          messagesEndRef={messagesEndRef}
                          deleteChatFlag={deleteChatFlag}
                          setDeleteChatFlag={setDeleteChatFlag}
                          setSelectedMessages={setSelectedMessages}
                          isDelMsgSelected={selectedMessages.includes(msg.id)}
                          handleCheckDelMsgChange={handleCheckDelMsgChange}
                          forwardChatFlag={forwardChatFlag}
                          isFwdMsgSelected={selectedForwardMessages.some((m) => m.id === msg.id)}
                          handleCheckForwardNessage={handleCheckForwardNessage}
                          setForwardChatFlag={setForwardChatFlag}
                          setReplyChatFlag={setReplyChatFlag}
                          setReplyMsg={setReplyMsg}
                          openPreview={openPreview}
                          // Pass audio control props
                          currentlyPlayingAudio={currentlyPlayingAudio}
                          setCurrentlyPlayingId={setCurrentlyPlayingId}
                          isPlaying={currentlyPlayingId === msg.id}
                          currentTime={currentTime}
                          setCurrentTime={setCurrentTime}
                          onAudioPlay={(audioElement) => handleAudioPlay(msg.id, audioElement)}
                        />
                      </React.Fragment>
                    );
                  })}
                  {(replyChatFlag || attachMultiFile.length > 0) && <div className="panel-height40"></div>}
                  {currMsg?.mediaUrl && <Preview currMsg={currMsg} onClose={closePreview} setModalAction={setModalAction} handleCheckForwardNessage={handleCheckForwardNessage} />}
                </React.Fragment>
              );
            })}
          </div>

          {/* Reply Section */}
          {(replyChatFlag || attachMultiFile.length > 0 || audioURL) && (
            <div className="chatrpybox row">
              <div className="chatreplyinnerbox col-sm-12 col-xs-12 reply-main">
                {isWideScreen && attachMultiFile.length > 3 && (
                  <i
                    className="fa fa-chevron-circle-left multiFile-arrow"
                    onClick={() => {
                      if (containerRef.current) {
                        containerRef.current.scrollBy({
                          left: -200, // Adjust scroll amount as needed
                          behavior: "smooth",
                        });
                      }
                    }}
                  />
                )}
                <div className={`${replyChatFlag ? "replytext" : "multiFile"}`} ref={containerRef}>
                  {attachMultiFile.length > 0 && !audioURL ? (
                    <>
                      {attachMultiFile.map((file, index) => (
                        <div className="file-preview" key={index}>
                          {imageExtensions.includes(getExtensionType(file?.filename)) ? (
                            <img
                              className="file-thumbnail"
                              src={file.data}  // Changed from imagePreview to file.data
                              alt="Preview"
                              style={{
                                maxWidth: "100px",
                                maxHeight: "100px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <img
                              className="br5"
                              style={{
                                height: "40px",
                                fontSize: "30px",
                                marginRight: "10px",
                              }}
                              src={
                                extensionIcons[file.filename.split(".").pop()]
                                  ? extensionIcons[file.filename.split(".").pop()]
                                  : file?.type.startsWith('audio')
                                    ? audio_file_icon
                                    : other_file_icon
                              }
                              alt={file.filename.split(".").pop()}
                            />
                          )}

                          <span className="file-name">{file.filename}</span>
                          <i
                            className="fa fa-times"
                            onClick={() => {
                              // Remove just this file from the array
                              setAttachMultiFile(prev => prev.filter((_, i) => i !== index));
                              setReplyMsg({});
                              setCurrentlyPlayingId(null);
                              setIsTyping(false);
                              setAudioURL(null);
                            }}
                          ></i>
                        </div>
                      ))}
                    </>
                  ) : audioURL ? (
                    <>
                      <div className="preview-player-container">
                        <div className="preview-control-button" onClick={() => {
                          if (audioRef.current) {
                            handleAudioPlay('preview', audioRef.current);
                          }
                        }}>
                          <div className="circle">
                            {/* <i className={`fa ${isPlaying ? "fa-pause" : "fa-play"}`}></i> */}
                            <i className={`fa ${currentlyPlayingId === 'preview' && !audioRef.current?.paused
                              ? "fa-pause"
                              : "fa-play"
                              }`} />
                          </div>
                        </div>
                        <div style={{ display: "ruby", margintop: "14px" }}>
                          <input
                            type="range"
                            value={currentTime}
                            max={audioRef.current?.duration || 0}
                            onChange={(e) => {
                              const audio = audioRef.current;
                              if (audio) {
                                audio.currentTime = e.target.value;
                                setCurrentTime(e.target.value);
                              }
                            }}
                            className="preview-seek-bar"
                          />
                          <audio
                            ref={audioRef}
                            src={audioURL}
                            onTimeUpdate={() => {
                              if (audioRef.current) {
                                setCurrentTime(audioRef.current.currentTime);
                              }
                            }}
                          />
                          <span className="preview-time">{recordingformatTime(Math.floor(currentTime))}</span>
                        </div>
                        <div
                          className="chatrpy-w10 fa fa-times"
                          onClick={() => handleCancelRecording()}
                        ></div>
                      </div>
                    </>
                  ) : (
                    <>
                      {replyChatFlag && (
                        <>
                          <div className="bigtext">{replyMsg?.userName}</div>
                          <div className="smalltext">{truncateWords(replyMsg?.message, 5)}</div>
                        </>
                      )}
                    </>
                  )}
                </div>
                {isWideScreen && attachMultiFile.length > 3 && (
                  <i
                    className="fa fa-chevron-circle-right multiFile-arrow"
                    onClick={() => {
                      if (containerRef.current) {
                        containerRef.current.scrollBy({
                          left: 200, // Adjust scroll amount as needed
                          behavior: "smooth",
                        });
                      }
                    }}
                  />
                )}

                {replyChatFlag && (
                  <>
                    <div className="chatrpy-w150">
                      {replyMsg?.mediaUrl && (
                        <img
                          className="file-thumbnail"
                          src={
                            imageExtensions.includes(replyMsg?.mediaUrl.split(".").pop().toLowerCase())
                              ? replyMsg?.mediaUrl
                              : extensionIcons[replyMsg?.mediaUrl.split(".").pop().toLowerCase()] ?
                                extensionIcons[replyMsg?.mediaUrl.split(".").pop().toLowerCase()] : audioExtensions.includes(replyMsg?.mediaUrl.split(".").pop().toLowerCase()) ? audio_file_icon : other_file_icon
                          }
                          alt="preview"
                        />
                      )}
                    </div>
                    <div
                      className="chatrpy-w10 fa fa-times"
                      onClick={() => { setReplyChatFlag(null); setReplyMsg({}) }}
                    ></div>
                  </>
                )}
              </div>
            </div>
          )}
          {/* FOOTER START */}
          {/* <div className="row reply "> */}
          <div
            className={`row reply   ${deleteChatFlag ? "dlt-select-btn" : ""}`}
          >
            {deleteChatFlag || forwardChatFlag ? (
              <>
                <div className="deletebox-main">
                  <div className="deletebox-left ">
                    Selected:{" "}
                    {selectedMessages.length || selectedForwardMessages.length}
                  </div>
                  <div className="deletebox-right ">
                    {forwardChatFlag ? (
                      <>
                        {selectedForwardMessages.length > 0 && (
                          <button
                            className="btn btn-success"
                            type="button"
                            aria-haspopup="true"
                            onClick={() =>
                              setModalAction({
                                ...modalAction,
                                forwardMsg: true,
                              })
                            }
                          >
                            Forward message
                          </button>
                        )}
                        <button
                          className="btn btn-danger cancelbtn-ml5"
                          type="button"
                          aria-haspopup="true"
                          onClick={handleCancelForwardMessage}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        {selectedMessages.length > 0 && (
                          <button
                            className="btn btn-danger cancelbtn-mr5"
                            type="button"
                            aria-haspopup="true"
                            onClick={() =>
                              setModalAction({
                                ...modalAction,
                                deleteMessage: true,
                              })
                            }
                          >
                            Delete Chat
                          </button>
                        )}
                        <button
                          className="btn btn-success"
                          type="button"
                          aria-haspopup="true"
                          onClick={handleSelectAllToggle}
                        >
                          {isAllSelected ? "Unselect All" : "Select All"}
                        </button>
                        <button
                          className="btn btn-danger cancelbtn-ml5"
                          type="button"
                          aria-haspopup="true"
                          onClick={handleCancelSelection}
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </>) :
              (<>
                {emojiPicker && (
                  <div
                    className="emojipicker"
                    onClick={(e) => e.stopPropagation()}
                    ref={emojiPickerRef}
                  >
                    <Picker onEmojiClick={onEmojiClick} className="test" />
                  </div>
                )}
                <div className="col-sm-12 col-xs-12 reply-main display-flex">
                  <div className="footer-textarea">
                    {!recording && <>
                      {!audioURL && <div className="footer-btn-new footerbtn-w50 ml-2">
                        <i className="fa fa-paperclip attac" onClick={() => fileInputRef.current.click()}></i>
                        <input type="file"
                          id="file-input"
                          ref={fileInputRef}
                          multiple
                          style={{ display: "none" }}
                          onChange={(event) => {
                            handleFileOnChange(event);
                            fileInputRef.current.value = "";
                            setImagePreview(null);
                          }} />
                      </div>}
                      <div className="emojimain">
                        <button onClick={() => setEmojiPicker(!emojiPicker)}
                          disabled={audioURL} type="button" className="file-upload-button subbtn">
                          <i className="fa fa-smile-o" aria-hidden="true"></i></button>
                      </div>
                    </>}
                    {recording ? (
                      <div className="recording-ui">
                        <i className="fa fa-trash" onClick={() => handleDeleterecording()} aria-hidden="true"></i>
                        <span className="recording-dot" />
                        <span className="recording-timer">{recordingformatTime(timer)}</span>
                        <div className="waveform-animation" />
                        {/* <span className="recording-level">00</span> */}
                      </div>
                    ) : (
                      <textarea className="form-control" rows="1" id="comment"
                        placeholder="Type your message..."
                        ref={textareaRef}
                        value={newMessage}
                        disabled={audioURL}
                        onChange={(e) => handleInputChange(e.target.value)}
                        onKeyDown={handleOnKeyDown}
                        onPaste={handlePasteImage}>
                      </textarea>)}
                    <div className="footer-btn-new footerbtn-w50">
                      {!audioURL && attachMultiFile.length === 0 && !isTyping && (<i
                        className={`fa ${recording ? 'fa-stop' : 'fa-microphone'} attac`}
                        aria-hidden="true"
                        onClick={recording ? stopRecording : startRecording}
                      ></i>)}
                    </div>
                    {!recording && <div className="footer-btn-new footerbtn-w50" >
                      <i
                        className={`fa fa-send font21 msend ${isSending ? "disabled" : ""}`}
                        onClick={!isSending && (newMessage.trim() || attachMultiFile?.length > 0) ? handleSendMessage : null}
                        style={{ opacity: isSending ? 0.5 : 1, cursor: isSending ? "not-allowed" : "pointer" }}
                      ></i>
                    </div>}
                  </div>

                </div>
              </>)}
          </div>
        </>
      )}
      {/* <div className="row">
        <div className="footer">sdsdsd</div>
      </div> */}
      {/* <div className="footer">sdsdsd</div> */}

      {/*----------------Update group delete group/ claer chat modal-------------------*/}
      {modalType && (
        <div className="modal-overlay">
          <Modal
            closeModal={closeModal}
            handleDelete={
              modalType === "group" ? handleDeleteGroup : handleClearChatClick
            }
            modalTitle={`Delete this ${modalType}?`}
            modalBody={`Are you sure you want to Delete this ${modalType}?`}
          />
        </div>
      )}

      {/*----------------Delete message modal-------------------*/}
      {modalAction?.deleteMessage && (
        <div className="modal-overlay">
          <Modal
            closeModal={closeModal}
            handleDelete={handleDeleteSelected}
            modalTitle={`Delete this message`}
            modalBody={`Are you sure you want to Delete messages?`}
          />
        </div>
      )}

      {/*----------------Leave group modal-------------------*/}
      {modalAction?.leaveGroup && (
        <div className="modal-overlay">
          <Modal
            closeModal={closeModal}
            handleDelete={handleLeaveGroup}
            modalTitle={`Leave this group`}
            modalBody={`Are you sure you want to Leave this group?`}
            submitBtnLabel={"Leave"}
          />
        </div>
      )}

      {/*----------------Update group modal-------------------*/}
      {modalAction?.updateGroup && (
        <div className="modal-overlay">
          <NewGroup
            closeModal={closeModal}
            allUserList={usersData}
            loginUserData={loginData}
            currGroup={currGroup}
            action="update"
          />
        </div>
      )}

      {/*----------------Show user list modal-------------------*/}
      {modalAction?.membersList && (
        <div className="modal-overlay">
          <NewGroup
            closeModal={closeModal}
            allUserList={usersData}
            loginUserData={loginData}
            currGroup={currGroup}
            action="viewMembers"
          />
        </div>
      )}
      {/*----------------Show user Profile-------------------*/}
      {modalAction?.userProfile && (
        <div className="modal-overlay">
          <UserProfileModal
            title={`Profile`}
            closeModal={closeModal}
            user={currChatUser}
          // handleDelete={handleLeaveGroup}
          // modalBody={`Are you sure you want to Leave this group?`}
          // submitBtnLabel={"Leave"}
          />
        </div>
      )}
      {/*----------------Show user list modal for forward message-------------------*/}
      {modalAction?.forwardMsg && (
        <div className="modal-overlay">
          <NewGroup
            closeModal={closeModal}
            allUserList={usersData}
            loginUserData={loginData}
            // currGroup={currGroup}
            action="forward"
            selectedForwardMessages={selectedForwardMessages}
          />
        </div>
      )}
    </>
  );
};

export default memo(Chat);
